import React, { useEffect, useRef, useState } from "react";

function Australiastudentvisaimport() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);
  const contentRef = useRef(null);

  useEffect(() => {
    sectionRefs.current = sectionRefs.current.slice(0, 9);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.indexOf(entry.target);
          setActiveIndex(index);
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollToSection = (index) => {
    setActiveIndex(index);
    const section = sectionRefs.current[index];
    const contentElement = contentRef.current;

    const scrollPosition = section.offsetTop - contentElement.offsetTop;

    contentElement.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex flex-wrap">
      <div className=" mt-20 flex min-h-screen">
        <div
          className="sticky top-20 hidden h-screen w-1/4 overflow-y-auto bg-gray-100 p-4 md:block"
        >
          <ul className="space-y-2">
            {[
              "Study in Australia: Your Gateway to Global Opportunities",
              "Globally Recognized Academic Excellence",
              "Strong Protections for International Students",
              "Significant Scholarships and Financial Support",
              "A Multicultural and Inclusive Environment",
              "Comprehensive Support from Visa World",
              "Key Visa Requirements and Conditions",
              "Visa Assessment Levels",
              "Documents Required for an Australian Student Visa",
            ].map((item, index) => (
              <li
                key={index}
                onClick={() => scrollToSection(index)}
                className={`cursor-pointer p-8 ${
                  activeIndex === index
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div
          ref={contentRef}
          className="mb-10 h-screen overflow-y-auto p-4 md:w-3/4 lg:w-3/4 xl:w-3/4"
        >
          {[
            [
              "Australia is one of the most sought-after destinations for students worldwide.",
              "Access to more than 22,000 courses at 1,100 universities.",
              "Expert faculty, numerous scholarships and a supportive ecosystem.",
            ],
            [
              "Australian degrees are highly regarded worldwide.",
              "Innovative teaching approaches and globally ranked institutions.",
              "Many universities feature in QS World University Rankings.",
            ],
            [
              "Australia ensures strong protections under the ESOS Act 2000.",
              "All educational programs meet stringent government standards.",
              "Provides a safe and reliable learning environment.",
            ],
            [
              "Over AUD 200 million in scholarships provided annually.",
              "Ensures access to world-class education for deserving students.",
              "Financial support reduces educational expenses significantly.",
            ],
            [
              "Australia is renowned for its cultural diversity.",
              "Communities from varied origins contribute to multiculturalism.",
              "Over 200 languages spoken nationwide offer inclusivity.",
            ],
            [
              "Visa World offers expert guidance for educational programs.",
              "Assists in finding courses tailored to career aspirations.",
              "Handles every aspect of visa applications with precision.",
            ],
            [
              "Maintain OSHC and remain enrolled with your institution.",
              "Notify changes in enrollment promptly to avoid cancellations.",
              "Adhere to all visa conditions for uninterrupted stay.",
            ],
            [
              "Applicants categorized into Assessment Levels (1-3).",
              "Higher levels require proof of financial capacity.",
              "English proficiency evidence may also be needed.",
            ],
            [
              "Valid passport and completed visa application form.",
              "OSHC, financial evidence and English proficiency proof.",
              "Additional documents based on specific requirements.",
            ],
          ].map((content, index) => (
            <div
              key={index}
              ref={(el) => (sectionRefs.current[index] = el)}
              className="mt-10"
            >
              <p className="text-xl font-bold text-[#011473]">
                {[
                  "Study in Australia: Your Gateway to Global Opportunities",
                  "Globally Recognized Academic Excellence",
                  "Strong Protections for International Students",
                  "Significant Scholarships and Financial Support",
                  "A Multicultural and Inclusive Environment",
                  "Comprehensive Support from Visa World",
                  "Key Visa Requirements and Conditions",
                  "Visa Assessment Levels",
                  "Documents Required for an Australian Student Visa",
                ][index]}
              </p>
              <ul className="mt-4 list-disc pl-5 text-md text-[#2C3F69]">
                {content.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Australiastudentvisaimport;
